<template>
    <div class="weekly-menu-container">
        <!-- 顶层 Tab：横屏交互屏 / 竖屏交互屏 -->
        <el-tabs type="border-card" v-model="activeTopTab" class="top-tabs" @tab-click="handleTopTabChange">
            <el-tab-pane label="横屏交互屏" name="horizontal">
                <!-- 横屏子Tab -->
                <el-tabs type="border-card" class="menu-tabs">
                    <!-- 今日菜单 -->
                    <el-tab-pane>
                        <span slot="label"><i class="el-icon-date"></i> 今日菜单</span>
                        <div class="today-menu">
                            <el-card shadow="hover">
                                <div class="menu-image-container">
                                    <img v-if="todayImage" :src="todayImage" class="menu-image" alt="今日菜单图片" />
                                    <div v-else class="empty-state">
                                        <i class="el-icon-picture-outline"></i>
                                        <p>暂无今日菜单图片</p>
                                    </div>
                                </div>
                                <div class="upload-area">
                                    <el-upload class="image-uploader" action="#" list-type="picture"
                                        :show-file-list="false" :http-request="handleTodayMenuHttpRequest"
                                        :before-upload="handleBeforeUpload" accept="image/jpeg,image/png">
                                        <el-button size="small" type="primary">上传今日菜单图片</el-button>
                                        <!-- 新增：显示大小限制提示 -->
                                        <div slot="tip" class="el-upload__tip">
                                            支持JPG/PNG格式，文件大小不超过200KB
                                        </div>
                                    </el-upload>
                                    <el-button v-if="todayImage" size="small" type="danger" style="margin-left: 10px;"
                                        @click="deleteTodayImage">
                                        删除今日菜单
                                    </el-button>
                                </div>
                            </el-card>
                        </div>
                    </el-tab-pane>

                    <!-- 每周食谱 -->
                    <el-tab-pane label="每周食谱">
                        <el-tabs type="border-card" class="date-sub-tab" @tab-click="handleDateTabChange">
                            <el-tab-pane label="周一"></el-tab-pane>
                            <el-tab-pane label="周二"></el-tab-pane>
                            <el-tab-pane label="周三"></el-tab-pane>
                            <el-tab-pane label="周四"></el-tab-pane>
                            <el-tab-pane label="周五"></el-tab-pane>
                            <el-tab-pane label="周六"></el-tab-pane>
                            <el-tab-pane label="周日"></el-tab-pane>
                        </el-tabs>

                        <!-- 菜品表格 -->
                        <el-card class="weekly-table-card" v-if="currentDayData">
                            <div class="table-container">
                                <div class="table-left">
                                    <div class="meal-item">早餐</div>
                                    <div class="meal-item">午餐</div>
                                    <div class="meal-item">晚餐</div>
                                    <div class="meal-item">宵夜</div>
                                </div>
                                <div class="table-right">
                                    <div class="meal-upload-item">
                                        <el-upload class="meal-uploader" action="#" list-type="picture-card"
                                            :file-list="currentDayData.breakfastFiles"
                                            :http-request="(options) => handleMealHttpRequest(options, currentDayData.id, 'breakfast')"
                                            :on-remove="(file) => handleRemove(file, currentDayData.id, 'breakfast')"
                                            :on-preview="handlePreview" :before-upload="handleBeforeUpload" :limit="1"
                                            accept="image/jpeg,image/png">
                                            <i class="el-icon-plus"></i>
                                            <!-- 新增：显示大小限制提示 -->
                                            <div slot="tip" class="el-upload__tip">
                                                支持JPG/PNG格式，文件大小不超过200KB
                                            </div>
                                        </el-upload>
                                    </div>
                                    <div class="meal-upload-item">
                                        <el-upload class="meal-uploader" action="#" list-type="picture-card"
                                            :file-list="currentDayData.lunchFiles"
                                            :http-request="(options) => handleMealHttpRequest(options, currentDayData.id, 'lunch')"
                                            :on-remove="(file) => handleRemove(file, currentDayData.id, 'lunch')"
                                            :on-preview="handlePreview" :before-upload="handleBeforeUpload" :limit="1"
                                            accept="image/jpeg,image/png">
                                            <i class="el-icon-plus"></i>
                                            <!-- 新增：显示大小限制提示 -->
                                            <div slot="tip" class="el-upload__tip">
                                                支持JPG/PNG格式，文件大小不超过200KB
                                            </div>
                                        </el-upload>
                                    </div>
                                    <div class="meal-upload-item">
                                        <el-upload class="meal-uploader" action="#" list-type="picture-card"
                                            :file-list="currentDayData.dinnerFiles"
                                            :http-request="(options) => handleMealHttpRequest(options, currentDayData.id, 'dinner')"
                                            :on-remove="(file) => handleRemove(file, currentDayData.id, 'dinner')"
                                            :on-preview="handlePreview" :before-upload="handleBeforeUpload" :limit="1"
                                            accept="image/jpeg,image/png">
                                            <i class="el-icon-plus"></i>
                                            <!-- 新增：显示大小限制提示 -->
                                            <div slot="tip" class="el-upload__tip">
                                                支持JPG/PNG格式，文件大小不超过200KB
                                            </div>
                                        </el-upload>
                                    </div>
                                    <div class="meal-upload-item">
                                        <el-upload class="meal-uploader" action="#" list-type="picture-card"
                                            :file-list="currentDayData.supperFiles"
                                            :http-request="(options) => handleMealHttpRequest(options, currentDayData.id, 'supper')"
                                            :on-remove="(file) => handleRemove(file, currentDayData.id, 'supper')"
                                            :on-preview="handlePreview" :before-upload="handleBeforeUpload" :limit="1"
                                            accept="image/jpeg,image/png">
                                            <i class="el-icon-plus"></i>
                                            <!-- 新增：显示大小限制提示 -->
                                            <div slot="tip" class="el-upload__tip">
                                                支持JPG/PNG格式，文件大小不超过200KB
                                            </div>
                                        </el-upload>
                                    </div>
                                </div>
                            </div>
                        </el-card>
                    </el-tab-pane>

                    <!-- 菜品公告 -->
                    <el-tab-pane label="菜品公告">
                        <el-card>
                            <div class="notice-container">
                                <el-input type="textarea" placeholder="输入菜品公告内容" v-model="noticeContent" rows="6"
                                    class="notice-input"></el-input>
                                <el-button type="primary" size="small" class="save-notice-btn" @click="saveNotice">
                                    保存公告
                                </el-button>
                                <div v-if="noticeUpdateTime" class="notice-time">最后更新：{{ noticeUpdateTime }}</div>
                            </div>
                        </el-card>
                    </el-tab-pane>

                    <!-- 食品检验报告 -->
                    <el-tab-pane label="食品检验报告">
                        <el-card>
                            <div class="report-container">
                                <el-upload class="report-uploader" action="#" list-type="file" :file-list="reportFiles"
                                    :http-request="handleReportHttpRequest" :on-remove="handleReportRemove"
                                    :before-upload="handleReportBeforeUpload" accept=".pdf,.doc,.docx,.xlsx">
                                    <el-button size="small" type="primary">上传检验报告</el-button>
                                    <div slot="tip" class="el-icon-file-text el-upload__tip">
                                        支持PDF、Word、Excel格式，单个文件不超过10MB
                                    </div>
                                </el-upload>
                                <div class="report-list" v-if="reportFiles.length">
                                    <div class="report-item" v-for="(file, index) in reportFiles" :key="index">
                                        <i :class="getFileIconClass(file.name)" class="report-icon"></i>
                                        <span class="report-name">{{ file.name }}</span>
                                        <span class="report-size">{{ formatFileSize(file.size) }}</span>
                                        <span class="report-time">{{ file.uploadTime }}</span>
                                        <div class="report-operate">
                                            <el-button size="mini" type="text" class="download-btn"
                                                @click="downloadReport(file)">
                                                下载
                                            </el-button>
                                            <el-button size="mini" type="text" class="delete-btn"
                                                @click="handleReportRemove(file)">
                                                删除
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-card>
                    </el-tab-pane>
                </el-tabs>
            </el-tab-pane>

            <!-- 竖屏交互屏 -->
            <el-tab-pane label="竖屏交互屏" name="vertical">
                <el-tabs type="border-card" class="vertical-sub-tabs">
                    <!-- 竖屏宣传图片 -->
                    <el-tab-pane label="上传宣传图片">
                        <el-card>
                            <div class="promotion-image-container">
                                <!-- 多张宣传图片展示区域 -->
                                <div class="image-preview-area" v-if="verticalPromotionImage.length">
                                    <div class="image-preview-list">
                                        <div class="preview-item" v-for="(img, index) in verticalPromotionImage"
                                            :key="img.id || index">
                                            <img :src="img.picUrl || img" class="promotion-image"
                                                :alt="`竖屏宣传图片${index + 1}`" />
                                            <el-button size="mini" type="text" class="delete-single-img"
                                                @click="deleteSingleVerticalImage(img)">
                                                <i class="el-icon-delete"></i>
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="empty-state">
                                    <i class="el-icon-picture-outline"></i>
                                    <p>暂无竖屏宣传图片</p>
                                </div>

                                <div class="upload-area">
                                    <el-upload class="image-uploader" action="#" list-type="picture"
                                        :show-file-list="false" :http-request="handleVerticalPromotionHttpRequest"
                                        :before-upload="handleBeforeUpload" accept="image/jpeg,image/png">
                                        <el-button size="small" type="primary">上传竖屏宣传图片</el-button>
                                        <!-- 新增：显示大小限制提示 -->
                                        <div slot="tip" class="el-upload__tip">
                                            支持JPG/PNG格式，文件大小不超过200KB
                                        </div>
                                    </el-upload>
                                </div>
                            </div>
                        </el-card>
                    </el-tab-pane>

                    <!-- 竖屏资质报告 -->
                    <el-tab-pane label="上传资质报告">
                        <el-card>
                            <div class="promotion-image-container">
                                <div class="image-preview-area" v-if="verticalQualificationFiles.length">
                                    <div class="image-preview-list">
                                        <div class="preview-item" v-for="(img, index) in verticalQualificationFiles"
                                            :key="img.uid || index">
                                            <img :src="img.picUrl" class="promotion-image"
                                                :alt="`竖屏资质图片${index + 1}`" />
                                            <el-button size="mini" type="text" class="delete-single-img"
                                                @click="handleVerticalQualificationRemove(img)">
                                                <i class="el-icon-delete"></i>
                                            </el-button>
                                        </div>
                                    </div>
                                </div>
                                <div v-else class="empty-state">
                                    <i class="el-icon-picture-outline"></i>
                                    <p>暂无资质图片</p>
                                </div>

                                <div class="upload-area">
                                    <el-upload class="image-uploader" action="#" list-type="picture"
                                        :show-file-list="false" :http-request="handleVerticalQualificationHttpRequest"
                                        :before-upload="handleBeforeUpload" accept="image/jpeg,image/png">
                                        <el-button size="small" type="primary">上传资质图片</el-button>
                                        <!-- 新增：显示大小限制提示 -->
                                        <div slot="tip" class="el-upload__tip">
                                            支持JPG/PNG格式，文件大小不超过200KB
                                        </div>
                                    </el-upload>
                                </div>
                            </div>
                        </el-card>
                    </el-tab-pane>
                </el-tabs>
            </el-tab-pane>
        </el-tabs>

        <!-- 图片预览弹窗 -->
        <el-dialog :visible.sync="previewVisible" title="图片预览" width="80%" append-to-body>
            <img :src="previewImage" alt="菜单预览" style="width: 100%; max-height: 80vh; object-fit: contain;" />
        </el-dialog>
    </div>
</template>

<script>
import { addCarousel, getCarouselList, delCarousel } from "@/api/promotion";

export default {
    name: "WeeklyMenuManagement",
    data() {
        return {
            // 顶层Tab激活状态
            activeTopTab: "horizontal",
            // 今日菜单
            todayImage: "",
            todayImageId: "",
            // 每周食谱
            activeDateTab: "周一",
            weekDays: [
                {
                    id: 1,
                    name: "周一",
                    breakfastFiles: [],
                    lunchFiles: [],
                    dinnerFiles: [],
                    supperFiles: [],
                    breakfastId: "",
                    lunchId: "",
                    dinnerId: "",
                    supperId: "",
                },
                {
                    id: 2,
                    name: "周二",
                    breakfastFiles: [],
                    lunchFiles: [],
                    dinnerFiles: [],
                    supperFiles: [],
                    breakfastId: "",
                    lunchId: "",
                    dinnerId: "",
                    supperId: "",
                },
                {
                    id: 3,
                    name: "周三",
                    breakfastFiles: [],
                    lunchFiles: [],
                    dinnerFiles: [],
                    supperFiles: [],
                    breakfastId: "",
                    lunchId: "",
                    dinnerId: "",
                    supperId: "",
                },
                {
                    id: 4,
                    name: "周四",
                    breakfastFiles: [],
                    lunchFiles: [],
                    dinnerFiles: [],
                    supperFiles: [],
                    breakfastId: "",
                    lunchId: "",
                    dinnerId: "",
                    supperId: "",
                },
                {
                    id: 5,
                    name: "周五",
                    breakfastFiles: [],
                    lunchFiles: [],
                    dinnerFiles: [],
                    supperFiles: [],
                    breakfastId: "",
                    lunchId: "",
                    dinnerId: "",
                    supperId: "",
                },
                {
                    id: 6,
                    name: "周六",
                    breakfastFiles: [],
                    lunchFiles: [],
                    dinnerFiles: [],
                    supperFiles: [],
                    breakfastId: "",
                    lunchId: "",
                    dinnerId: "",
                    supperId: "",
                },
                {
                    id: 7,
                    name: "周日",
                    breakfastFiles: [],
                    lunchFiles: [],
                    dinnerFiles: [],
                    supperFiles: [],
                    breakfastId: "",
                    lunchId: "",
                    dinnerId: "",
                    supperId: "",
                },
            ],
            // 图片预览
            previewVisible: false,
            previewImage: "",
            // 菜品公告
            noticeContent: "",
            noticeUpdateTime: "",
            // 检验报告
            reportFiles: [],
            // 竖屏相关 - 修改为数组存储多张图片
            verticalPromotionImage: [],
            verticalQualificationFiles: [],
            // 通用参数
            userId: localStorage.getItem("userId") || "",
            // 关键修改1：定义200KB的大小限制常量（字节数）
            maxImageSize: 200 * 1024, // 204800 字节 = 200KB
        };
    },
    computed: {
        currentDayData() {
            return this.weekDays.find((day) => day.name === this.activeDateTab);
        },
    },
    methods: {
        // 顶层Tab切换
        async handleTopTabChange(tab) {
            if (tab.name === "vertical") {
                await this.loadVerticalPromotionImage();
                await this.loadVerticalQualificationFiles();
            } else if (tab.name === "horizontal") {
                await this.loadTodayImage();
            }
        },

        // ===================== 通用方法 =====================
        // 关键修改2：修改图片文件前置校验（从5MB改为200KB）
        handleBeforeUpload(file) {
            const isImage = file.type === "image/jpeg" || file.type === "image/png";
            // 计算文件大小（200KB）
            const isLt200K = file.size <= this.maxImageSize;

            if (!isImage) {
                this.$message.error("请上传JPG/PNG格式的图片！");
                return false;
            }
            if (!isLt200K) {
                // 优化提示文案，显示具体大小
                this.$message.error(`图片大小不能超过200KB！当前大小：${this.formatFileSize(file.size)}`);
                return false;
            }
            return true;
        },

        // 资质报告前置校验（10MB限制）- 保留原逻辑（文件上传）
        handleQualificationBeforeUpload(file) {
            const isLt10M = file.size / 1024 / 1024 < 10;
            if (!isLt10M) {
                this.$message.error("文件大小不能超过10MB！");
                return false;
            }
            return true;
        },

        // 检验报告前置校验（10MB限制）- 保留原逻辑（文件上传）
        handleReportBeforeUpload(file) {
            const isLt10M = file.size / 1024 / 1024 < 10;
            if (!isLt10M) {
                this.$message.error("文件大小不能超过10MB！");
                return false;
            }
            return true;
        },

        // 图片预览
        handlePreview(file) {
            if (!file) return;
            try {
                this.previewImage = file.url || URL.createObjectURL(file.raw || file);
                this.previewVisible = true;
            } catch (e) {
                console.error("预览图片失败：", e);
                this.$message.error("图片预览失败！");
            }
        },

        // 关键修改3：优化文件大小格式化方法，更精准显示KB
        formatFileSize(size) {
            if (size < 1024) return `${size} B`;
            if (size < 1024 * 1024) return `${(size / 1024).toFixed(2)} KB`;
            return `${(size / 1024 / 1024).toFixed(2)} MB`;
        },

        // 获取文件图标类名
        getFileIconClass(fileName) {
            const ext = fileName.split(".").pop().toLowerCase();
            switch (ext) {
                case "pdf":
                    return "el-icon-file-pdf";
                case "doc":
                case "docx":
                    return "el-icon-file-word";
                case "xls":
                case "xlsx":
                    return "el-icon-file-excel";
                case "jpg":
                case "png":
                    return "el-icon-picture";
                default:
                    return "el-icon-file-text";
            }
        },

        // ===================== 横屏 - 今日菜单 =====================
        // 加载今日菜单
        async loadTodayImage() {
            try {
                const res = await getCarouselList({
                    userId: this.userId,
                    picType: "横屏今日菜单",
                });
                if (res.success && res.data.length > 0) {
                    this.todayImage = res.data[0].picUrl;
                    this.todayImageId = res.data[0].id;
                }
            } catch (error) {
                console.error("加载今日菜单失败：", error);
                this.$message.error("加载今日菜单失败！");
            }
        },

        // 今日菜单自定义上传
        async handleTodayMenuHttpRequest(options) {
            const file = options.file;
            try {
                // 额外校验：防止绕过前端限制
                if (file.size > this.maxImageSize) {
                    this.$message.error(`图片大小不能超过200KB！当前大小：${this.formatFileSize(file.size)}`);
                    return options.onError(new Error("文件大小超限"));
                }

                // 组装FormData
                const formData = new FormData();
                formData.append("file", file);
                formData.append("picName", file.name);
                formData.append("picType", "横屏今日菜单");
                formData.append("sort", 1);
                formData.append("userId", this.userId);

                // 删除原有图片
                if (this.todayImageId) {
                    await delCarousel({ id: this.todayImageId, userId: this.userId });
                }

                // 调用上传接口
                const res = await addCarousel(formData);
                if (res.success) {
                    this.todayImage = res.data.picUrl;
                    this.todayImageId = res.data.id;
                    options.onSuccess(res.data);
                    this.$message.success("今日菜单上传成功！");
                } else {
                    throw new Error(res.message || "上传失败");
                }
            } catch (error) {
                console.error("今日菜单上传失败：", error);
                options.onError(error);
                this.$message.error(`今日菜单上传失败：${error.message}`);
            }
        },

        // 删除今日菜单
        async deleteTodayImage() {
            try {
                await this.$confirm("确定删除今日菜单吗？", "提示", { type: "warning" });
                if (this.todayImageId) {
                    await delCarousel({ id: this.todayImageId, userId: this.userId });
                }
                this.todayImage = "";
                this.todayImageId = "";
                this.$message.success("今日菜单已删除！");
            } catch (error) {
                if (error !== "cancel") {
                    console.error("删除今日菜单失败：", error);
                    this.$message.error("删除今日菜单失败！");
                }
            }
        },

        // ===================== 横屏 - 每周食谱 =====================
        // 日期Tab切换
        handleDateTabChange(tab) {
            this.activeDateTab = tab.label || "周一";
        },

        // 餐食图片自定义上传
        async handleMealHttpRequest(options, dayId, mealType) {
            const file = options.file;
            const day = this.weekDays.find((d) => d.id === dayId);
            if (!day) return options.onError(new Error("未找到对应日期"));

            try {
                // 额外校验：防止绕过前端限制
                if (file.size > this.maxImageSize) {
                    this.$message.error(`${day.name}${this.getMealName(mealType)}图片大小不能超过200KB！当前大小：${this.formatFileSize(file.size)}`);
                    return options.onError(new Error("文件大小超限"));
                }

                // 组装FormData
                const formData = new FormData();
                formData.append("file", file);
                formData.append("picName", file.name);
                formData.append("picType", `横屏每周食谱_${day.name}_${mealType}`);
                formData.append("sort", 1);
                formData.append("userId", this.userId);

                // 删除原有图片
                if (day[`${mealType}Id`]) {
                    await delCarousel({ id: day[`${mealType}Id`], userId: this.userId });
                }

                // 调用上传接口
                const res = await addCarousel(formData);
                if (res.success) {
                    day[`${mealType}Files`] = [
                        {
                            name: file.name,
                            url: res.data.picUrl,
                            uid: res.data.id,
                            raw: file,
                        },
                    ];
                    day[`${mealType}Id`] = res.data.id;
                    options.onSuccess(res.data);
                    this.$message.success(`${day.name}${this.getMealName(mealType)}上传成功！`);
                } else {
                    throw new Error(res.message || "上传失败");
                }
            } catch (error) {
                console.error(`${day.name}${this.getMealName(mealType)}上传失败：`, error);
                options.onError(error);
                this.$message.error(`${day.name}${this.getMealName(mealType)}上传失败：${error.message}`);
            }
        },

        // 餐食图片删除
        async handleRemove(file, dayId, mealType) {
            const day = this.weekDays.find((d) => d.id === dayId);
            if (!day) return;

            try {
                await this.$confirm(`确定删除${day.name}${this.getMealName(mealType)}吗？`, "提示", { type: "warning" });
                // 调用删除接口
                if (day[`${mealType}Id`]) {
                    await delCarousel({ id: day[`${mealType}Id`], userId: this.userId });
                }
                // 释放URL + 更新列表
                if (file.url && file.url.startsWith("blob:")) {
                    URL.revokeObjectURL(file.url);
                }
                day[`${mealType}Files`] = [];
                day[`${mealType}Id`] = "";
                this.$message.success(`${day.name}${this.getMealName(mealType)}已删除！`);
            } catch (error) {
                if (error !== "cancel") {
                    console.error(`${day.name}${this.getMealName(mealType)}删除失败：`, error);
                    this.$message.error("删除失败！");
                }
            }
        },

        // 获取餐次名称
        getMealName(mealType) {
            const names = {
                breakfast: "早餐",
                lunch: "午餐",
                dinner: "晚餐",
                supper: "宵夜",
            };
            return names[mealType] || "";
        },

        // ===================== 横屏 - 菜品公告 =====================
        saveNotice() {
            if (!this.noticeContent.trim()) {
                return this.$message.warning("请输入公告内容！");
            }
            localStorage.setItem("dishNotice", this.noticeContent);
            this.noticeUpdateTime = new Date().toLocaleString();
            localStorage.setItem("noticeUpdateTime", this.noticeUpdateTime);
            this.$message.success("公告保存成功！");
        },

        // ===================== 横屏 - 检验报告 =====================
        // 检验报告自定义上传
        async handleReportHttpRequest(options) {
            const file = options.file;
            try {
                const formData = new FormData();
                formData.append("file", file);
                formData.append("picName", file.name);
                formData.append("picType", "横屏检验报告");
                formData.append("sort", this.reportFiles.length + 1);
                formData.append("userId", this.userId);

                const res = await addCarousel(formData);
                if (res.success) {
                    this.reportFiles.push({
                        name: file.name,
                        uid: res.data.id,
                        size: file.size,
                        url: res.data.picUrl || "#",
                        uploadTime: new Date().toLocaleString(),
                    });
                    options.onSuccess(res.data);
                    this.$message.success("检验报告上传成功！");
                } else {
                    throw new Error(res.message || "上传失败");
                }
            } catch (error) {
                console.error("检验报告上传失败：", error);
                options.onError(error);
                this.$message.error(`检验报告上传失败：${error.message}`);
            }
        },

        // 检验报告删除
        async handleReportRemove(file) {
            try {
                await this.$confirm("确定删除该检验报告吗？", "提示", { type: "warning" });
                if (file.uid) {
                    await delCarousel({ id: file.uid, userId: this.userId });
                }
                this.reportFiles = this.reportFiles.filter((item) => item.uid !== file.uid);
                this.$message.success("检验报告已删除！");
            } catch (error) {
                if (error !== "cancel") {
                    console.error("检验报告删除失败：", error);
                    this.$message.error("删除失败！");
                }
            }
        },

        // 检验报告下载
        downloadReport(file) {
            if (file.url && file.url !== "#") {
                window.open(file.url, "_blank");
            } else {
                this.$message.warning("暂无下载地址！");
            }
        },

        // ===================== 竖屏 - 宣传图片 =====================
        // 加载竖屏宣传图片
        async loadVerticalPromotionImage() {
            try {
                const res = await getCarouselList({
                    userId: this.userId,
                    picType: "竖屏宣传图",
                });
                console.log(res);

                if (res.data.length > 0) {
                    this.verticalPromotionImage = res.data;
                    console.log(this.verticalPromotionImage);
                } else {
                    this.verticalPromotionImage = [];
                }
            } catch (error) {
                console.error("加载竖屏宣传图失败：", error);
                this.$message.error("加载竖屏宣传图失败！");
                this.verticalPromotionImage = [];
            }
        },

        // 竖屏宣传图片自定义上传
        async handleVerticalPromotionHttpRequest(options) {
            const file = options.file;
            try {
                // 额外校验：防止绕过前端限制
                if (file.size > this.maxImageSize) {
                    this.$message.error(`竖屏宣传图片大小不能超过200KB！当前大小：${this.formatFileSize(file.size)}`);
                    return options.onError(new Error("文件大小超限"));
                }

                const formData = new FormData();
                formData.append("file", file);
                formData.append("picName", file.name);
                formData.append("picType", "竖屏宣传图");
                formData.append("sort", this.verticalPromotionImage.length + 1);
                formData.append("userId", this.userId);

                const res = await addCarousel(formData);

                // 添加新上传的图片到数组
                this.verticalPromotionImage.push({
                    id: res.data.id,
                    picUrl: res.data.picUrl,
                    picName: file.name,
                    createTime: new Date().toLocaleString()
                });
                options.onSuccess(res.data);
                this.$message.success("竖屏宣传图片上传成功！");
                this.loadVerticalPromotionImage()
            } catch (error) {
                console.error("竖屏宣传图上传失败：", error);
                options.onError(error);
                this.$message.error(`竖屏宣传图上传失败：${error.message}`);
            }
        },

        // 删除单张竖屏宣传图片
        async deleteSingleVerticalImage(img) {
            try {
                // 参数校验
                if (!img || !img.id) {
                    this.$message.warning("无效的宣传图片！");
                    return;
                }

                await this.$confirm("确定删除这张宣传图片吗？", "提示", { type: "warning" });

                // 调用删除接口
                await delCarousel({ id: img.id, userId: this.userId });

                // 从数组中移除该图片
                this.verticalPromotionImage = this.verticalPromotionImage.filter(item => item.id !== img.id);
                this.$message.success("宣传图片已删除！");
            } catch (error) {
                if (error !== "cancel") {
                    console.error("删除竖屏宣传图失败：", error);
                    this.$message.error("删除失败！");
                }
            }
        },

        // ===================== 竖屏 - 资质报告 =====================
        // 加载竖屏资质报告
        async loadVerticalQualificationFiles() {
            try {
                const res = await getCarouselList({
                    userId: this.userId,
                    picType: "竖屏资质报告",
                });

                this.verticalQualificationFiles = res.data.map((item) => ({
                    id: item.id,
                    uid: item.id,
                    name: item.picName,
                    size: item.fileSize || 0,
                    picUrl: item.picUrl || "#",
                    uploadTime: item.createTime || new Date().toLocaleString(),
                }));

            } catch (error) {
                console.error("加载竖屏资质报告失败：", error);
                this.$message.error("加载竖屏资质报告失败！");
            }
        },

        // 竖屏资质报告自定义上传
        async handleVerticalQualificationHttpRequest(options) {
            const file = options.file;
            try {
                // 额外校验：防止绕过前端限制
                if (file.size > this.maxImageSize) {
                    this.$message.error(`竖屏资质图片大小不能超过200KB！当前大小：${this.formatFileSize(file.size)}`);
                    return options.onError(new Error("文件大小超限"));
                }

                const formData = new FormData();
                formData.append("file", file);
                formData.append("picName", file.name);
                formData.append("picType", "竖屏资质报告");
                formData.append("sort", this.verticalQualificationFiles.length + 1);
                formData.append("userId", this.userId);

                const res = await addCarousel(formData);

                this.verticalQualificationFiles.push({
                    id: res.data.id,
                    uid: res.data.id,
                    name: file.name,
                    size: file.size,
                    picUrl: res.data.picUrl || "#",
                    uploadTime: new Date().toLocaleString(),
                });
                options.onSuccess(res.data);
                await this.loadVerticalQualificationFiles()
                this.$message.success("资质报告上传成功！");

            } catch (error) {
                console.error("竖屏资质报告上传失败：", error);
                options.onError(error);
                this.$message.error(`资质报告上传失败：${error.message}`);
            }
        },

        // 竖屏资质报告删除
        async handleVerticalQualificationRemove(file) {
            // 参数校验
            if (!file || (!file.uid && !file.id)) {
                this.$message.warning("无效的资质文件！");
                return;
            }

            try {
                await this.$confirm("确定删除该资质报告吗？", "提示", { type: "warning" });

                // 调用后端删除接口
                const deleteId = file.uid || file.id;
                if (deleteId) {
                    await delCarousel({ id: deleteId, userId: this.userId });
                }

                // 前端过滤数组
                this.verticalQualificationFiles = this.verticalQualificationFiles.filter(
                    (item) => item.uid !== deleteId
                );

                // 重新加载数据，确保与后端一致
                await this.loadVerticalQualificationFiles();

                this.$message.success("资质报告已删除！");
            } catch (error) {
                if (error !== "cancel") {
                    console.error("删除资质报告失败：", error);
                    this.$message.error("删除失败！");
                }
            }
        },

        // 竖屏资质报告下载
        downloadVerticalQualification(file) {
            if (file.url && file.url !== "#") {
                window.open(file.url, "_blank");
            } else {
                this.$message.warning("暂无下载地址！");
            }
        },
    },
    mounted() {
        // 初始化加载数据
        if (this.activeTopTab === "horizontal") {
            this.loadTodayImage();
        } else {
            this.loadVerticalPromotionImage();
            this.loadVerticalQualificationFiles();
        }

        // 加载本地公告
        const savedNotice = localStorage.getItem("dishNotice");
        const savedTime = localStorage.getItem("noticeUpdateTime");
        if (savedNotice) this.noticeContent = savedNotice;
        if (savedTime) this.noticeUpdateTime = savedTime;
    },
    beforeDestroy() {
        // 释放blob URL
        this.weekDays.forEach((day) => {
            ["breakfastFiles", "lunchFiles", "dinnerFiles", "supperFiles"].forEach((type) => {
                day[type].forEach((file) => {
                    if (file.url && file.url.startsWith("blob:")) {
                        URL.revokeObjectURL(file.url);
                    }
                });
            });
        });
        if (this.todayImage?.startsWith("blob:")) {
            URL.revokeObjectURL(this.todayImage);
        }
        // 释放竖屏宣传图片的blob URL
        this.verticalPromotionImage.forEach(img => {
            if (img.picUrl?.startsWith("blob:")) {
                URL.revokeObjectURL(img.picUrl);
            }
        });
        this.verticalQualificationFiles.forEach((file) => {
            if (file.url && file.url.startsWith("blob:")) {
                URL.revokeObjectURL(file.url);
            }
        });
    },
};
</script>

<style lang="scss" scoped>
.weekly-menu-container {
    padding: 20px;
    background-color: #f5f7fa;
    min-height: calc(100vh - 40px);
}

/* 顶层Tab样式 */
.top-tabs {
    margin-bottom: 20px;

    .el-tabs__item {
        font-size: 16px;
        padding: 0 20px;
        height: 45px;
        line-height: 45px;
    }

    .el-tabs__active-bar {
        height: 3px;
        background-color: #409eff;
    }
}

/* 横屏子Tab样式 */
.menu-tabs {
    background-color: #fff;

    .el-tabs__content {
        padding: 15px;
    }
}

/* 竖屏子Tab样式 */
.vertical-sub-tabs {
    background-color: #fff;

    .el-tabs__content {
        padding: 15px;
    }

    .el-tabs__item {
        font-size: 14px;
        padding: 0 15px;
    }
}

/* 今日菜单样式 */
.today-menu {
    .menu-image-container {
        width: 100%;
        height: 400px;
        display: flex;
        align-items: center;
        justify-content: center;
        border: 1px dashed #e4e7ed;
        margin-bottom: 15px;

        .menu-image {
            max-width: 100%;
            max-height: 100%;
            object-fit: contain;
            box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
            transition: all 0.3s ease;

            &:hover {
                transform: scale(1.02);
            }
        }

        .empty-state {
            text-align: center;
            color: #909399;

            i {
                font-size: 48px;
                margin-bottom: 10px;
                display: block;
            }
        }
    }

    .upload-area {
        text-align: right;

        // 新增：调整上传提示样式
        .el-upload__tip {
            display: block;
            margin-top: 5px;
            font-size: 12px;
            color: #909399;
        }
    }
}

/* 每周食谱样式 */
.date-sub-tab {
    margin-bottom: 15px;

    .el-tabs__header {
        margin-bottom: 10px;
    }

    .el-tabs__item {
        min-width: 80px;
        text-align: center;
    }
}

.weekly-table-card {
    overflow-x: auto;
}

.table-container {
    display: flex;
    border: 1px solid #e4e7ed;
    border-radius: 4px;
    overflow: hidden;
}

.table-left {
    width: 120px;
    background-color: #f5f7fa;
    height: 67vh;
}

.meal-item {
    height: 16vh;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 1px solid #e4e7ed;
    font-weight: 500;
    text-align: center;
    padding: 10px;

    &:last-child {
        border-bottom: none;
    }
}

.table-right {
    flex: 1;
}

.meal-upload-item {
    padding: 0 20px;
    border-bottom: 1px solid #e4e7ed;
    height: 16vh;
    display: flex;
    align-items: center;

    &:last-child {
        border-bottom: none;
    }

    .meal-uploader {
        width: 100%;

        // 新增：调整上传提示样式
        .el-upload__tip {
            font-size: 12px;
            color: #909399;
            margin-top: 5px;
        }
    }
}

/* 菜品公告样式 */
.notice-container {
    padding: 10px 0;

    .notice-input {
        margin-bottom: 15px;
    }

    .save-notice-btn {
        margin-bottom: 10px;
    }

    .notice-time {
        color: #909399;
        font-size: 12px;
    }
}

/* 检验报告通用样式 */
.report-container,
.qualification-report-container {
    padding: 10px 0;

    .report-uploader {
        margin-bottom: 20px;
    }

    .report-list {
        border-top: 1px solid #e4e7ed;
        padding-top: 15px;
    }

    .report-item {
        display: flex;
        align-items: center;
        padding: 10px 0;
        border-bottom: 1px dashed #e4e7ed;

        &:last-child {
            border-bottom: none;
        }

        .report-icon {
            margin-right: 10px;
            color: #409eff;
            font-size: 18px;
        }

        .el-icon-file-pdf {
            color: #e53935;
        }

        .el-icon-file-word {
            color: #1e88e5;
        }

        .el-icon-file-excel {
            color: #43a047;
        }

        .el-icon-picture {
            color: #f57c00;
        }

        .report-name {
            flex: 1;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin-right: 15px;
        }

        .report-size {
            color: #909399;
            font-size: 12px;
            margin-right: 15px;
            min-width: 60px;
        }

        .report-time {
            color: #909399;
            font-size: 12px;
            margin-right: 15px;
            min-width: 140px;
        }

        .report-operate {
            display: flex;

            .download-btn {
                color: #409eff;
                margin-right: 10px;
            }

            .delete-btn {
                color: #f56c6c;
            }
        }
    }
}

/* 竖屏宣传图片样式 */
.promotion-image-container {
    padding: 10px 0;

    .image-preview-area {
        width: 100%;
        min-height: 400px;
        display: flex;
        align-items: flex-start;
        justify-content: flex-start;
        border: 1px dashed #e4e7ed;
        margin-bottom: 15px;
        padding: 20px;
        height: 65vh;
        overflow: auto;

        .image-preview-list {
            width: 100%;
            display: flex;
            flex-wrap: wrap;
            gap: 20px;
            justify-content: flex-start;
        }

        .preview-item {
            position: relative;
            width: calc(33.333% - 14px);
            height: 200px;
            border: 1px solid #e4e7ed;
            border-radius: 4px;
            overflow: hidden;

            .promotion-image {
                width: 100%;
                height: 100%;

                transition: all 0.3s ease;

                &:hover {
                    transform: scale(1.05);
                }
            }

            .delete-single-img {
                position: absolute;
                top: 5px;
                right: 5px;
                width: 24px;
                height: 24px;
                background: rgba(255, 255, 255, 0.8);
                border-radius: 50%;
                display: flex;
                align-items: center;
                justify-content: center;
                color: #f56c6c;
                opacity: 0;
                transition: opacity 0.3s ease;

                i {
                    font-size: 14px;
                }
            }

            &:hover .delete-single-img {
                opacity: 1;
            }
        }
    }

    .empty-state {
        width: 100%;
        height: 400px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #909399;

        i {
            font-size: 48px;
            margin-bottom: 10px;
            display: block;
        }
    }

    .upload-area {
        text-align: right;

        // 新增：调整上传提示样式
        .el-upload__tip {
            display: block;
            margin-top: 5px;
            font-size: 12px;
            color: #909399;
        }
    }
}

/* 响应式适配 */
@media (max-width: 992px) {
    .table-left {
        width: 100px;
    }

    .meal-item {
        height: 160px;
    }

    .promotion-image-container .preview-item {
        width: calc(50% - 10px);
    }
}

@media (max-width: 768px) {
    .weekly-menu-container {
        padding: 10px;
    }

    .report-time {
        display: none;
    }

    .promotion-image-container .preview-item {
        width: 100%;
    }
}

@media (max-width: 576px) {
    .table-left {
        width: 80px;
    }

    .meal-item {
        height: 140px;
        font-size: 14px;
    }

    .report-size {
        display: none;
    }
}
</style>